import { Check, CheckCheck, Circle, Send, XCircle } from "lucide-react";

export const MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
export const DAYS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
export const ymd = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;

export const STATUS_STYLE = {
  prospect: { icon: Circle, color: "text-stone-400", card: "" },
  devis_envoye: { icon: Send, color: "text-[#FF6A00]", card: "" },
  confirme: { icon: Check, color: "text-emerald-400", card: "" },
  realise: { icon: CheckCheck, color: "text-blue-400", card: "" },
  refuse: { icon: XCircle, color: "text-red-400", card: "border-red-500/30 bg-red-500/10" },
  annule: { icon: XCircle, color: "text-red-400", card: "border-red-500/30 bg-red-500/10" },
};

export const startOfWeek = (d) => { const x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x; };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

export function rangeDays(mode, cursor) {
  if (mode === "week") return Array.from({ length: 7 }, (_, i) => addDays(startOfWeek(cursor), i));
  const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const last = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0);
  const start = startOfWeek(first);
  const n = Math.ceil(((last - start) / 86400000 + 1) / 7) * 7;
  return Array.from({ length: n }, (_, i) => addDays(start, i));
}

export function eventTime(e) {
  const times = (e.steps || []).map((s) => s.time).filter(Boolean).sort();
  if (times.length) return times[0];
  const m = /T(\d{2}:\d{2})/.exec(e.delivery_at || "");
  return m ? m[1] : "";
}

export function rangeLabel(mode, cursor) {
  if (mode !== "week") return `${MONTHS[cursor.getMonth()]} ${cursor.getFullYear()}`;
  const s = startOfWeek(cursor);
  const e = addDays(s, 6);
  const f = (d, y) => d.toLocaleDateString("fr-FR", { day: "numeric", month: "short", ...(y ? { year: "numeric" } : {}) });
  return `${f(s)} – ${f(e, true)}`;
}
